import { render, staticRenderFns } from "./GithubThemes.vue?vue&type=template&id=517211d4&scoped=true&"
import script from "./GithubThemes.vue?vue&type=script&lang=js&"
export * from "./GithubThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517211d4",
  null
  
)

export default component.exports